import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.33574 10.1598C6.79811 10.1598 4.74095 8.10928 4.74095 5.57988C4.74095 3.05048 6.79811 1 9.33574 1C11.8734 1 13.9305 3.05048 13.9305 5.57988C13.9305 8.10928 11.8734 10.1598 9.33574 10.1598Z",
  stroke: "black",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);

const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.999984 13.8237L6.11951 8.78586",
  stroke: "black",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconBase = _resolveComponent("IconBase");

  return _openBlock(), _createBlock(_component_IconBase, {
    "view-box": "0 0 15 15",
    "icon-name": "loupe",
    width: $props.width,
    height: $props.height,
    iconColor: "none"
  }, {
    default: _withCtx(() => [_hoisted_1, _hoisted_2]),
    _: 1
  }, 8, ["width", "height"]);
}